<table>
    <thead>
        <tr>
            <th class="subtable short sortable" (click)="toOrderBy('1')" [appSort]="listaCultivosMarca" data-order="desc" data-name="desMarca">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoMarca.marca' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('1')"></i>
              </div>
            </th>
            <th class="subtable short sortable" (click)="toOrderBy('2')" [appSort]="listaCultivosMarca" data-order="desc" data-name="aforo">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoMarca.aforo' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('2')"></i>
              </div>
            </th>
            <th class="subtable short sortable" (click)="toOrderBy('3')" [appSort]="listaCultivosMarca" data-order="desc" data-name="porcentajeSobreAforoCultivo">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoMarca.porcentaje' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('3')"></i>
              </div>
            </th>
            <th class="subtable action">
                <i class="fas fa-plus" *ngIf="campanyaHabilitada && (this.role === 'Administrador' || this.claims.includes('CULMAR_Ins'))"
                  (click)="new=true;editables=''" title="{{'mantenimientoCultivos.tabs.cultivos.cultivoMarca.tituloNew' | translate}}"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <app-cultivo-marca-new-edit class="component-in-row" *ngIf="new" [editable]="true" [campanyaHabilitada]="campanyaHabilitada" [cultivoId]="_cultivoId" [paisId]="paisId" [denominacionId]="denominacionId" [desFinca]="desFinca" [aforoDisponible]="aforoDisponible" (close)="new=$event"
        (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
        </app-cultivo-marca-new-edit>
        <app-cultivo-marca-new-edit class="component-in-row" *ngFor="let cultivoMarca of listaCultivosMarca" [campanyaHabilitada]="campanyaHabilitada" [paisId]="paisId" [denominacionId]="denominacionId" [cultivoMarca]="cultivoMarca" [aforoDisponible]="aforoDisponible" [editable]="cultivoMarca === editables" [cultivoId]="_cultivoId" [desFinca]="desFinca"
        (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
        </app-cultivo-marca-new-edit>
    </tbody>
    <tfoot *ngIf="!new && (!listaCultivosMarca || (listaCultivosMarca && listaCultivosMarca.length < 1))">
        <tr>
          <td colspan="4">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>
